import { motion } from 'framer-motion';

type Industry = {
  label: string;
  detail: string;
  icon: React.ReactNode;
};

const industries: Industry[] = [
  {
    label: 'Pharma',
    detail: 'Sales force automation, analytics, CRM',
    icon: <path d="M12 2v8m0 0a4 4 0 014 4v4a4 4 0 01-4 4 4 4 0 01-4-4v-4a4 4 0 014-4z M8 10h8" />,
  },
  {
    label: 'Recruitment',
    detail: 'Job agencies, candidate workflows',
    icon: <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2 M9 11a4 4 0 100-8 4 4 0 000 8z M22 11l-3-3-3 3 M19 8v9" />,
  },
  {
    label: 'Utilities',
    detail: 'Municipal operators, billing, field ops',
    icon: <path d="M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z" />,
  },
  {
    label: 'Hospitality',
    detail: 'Hotels, F&B, channel distribution',
    icon: <path d="M3 21V8l9-5 9 5v13 M9 21V12h6v9 M3 21h18" />,
  },
  {
    label: 'Invoicing & Inventory',
    detail: 'SaaS billing, stock, Shopify',
    icon: <path d="M9 3v18 M3 9h18 M3 15h18 M15 3v18" />,
  },
  {
    label: 'Education / Public sector',
    detail: 'Faculties, payment integrations',
    icon: <path d="M4 10l8-5 8 5-8 5-8-5z M4 10v6c0 2 4 4 8 4s8-2 8-4v-6 M12 15v6" />,
  },
  {
    label: 'Marketing ops',
    detail: 'Agency event and campaign tools',
    icon: <path d="M3 11l18-8-8 18-2-8-8-2z" />,
  },
];

export default function Industries() {
  return (
    <section className="container-page py-12 md:py-16">
      <div className="rounded-3xl border border-white/10 bg-white/[0.02] p-6 md:p-10">
        <div className="flex flex-wrap items-baseline justify-between gap-3">
          <p className="eyebrow">Industries we've shipped into</p>
          <p className="text-xs text-white/45">
            Verticals across North Macedonia and the Balkans — same playbook, software shaped to the workflow.
          </p>
        </div>
        <div className="mt-6 grid grid-cols-2 gap-3 md:grid-cols-4 lg:grid-cols-7">
          {industries.map((ind, i) => (
            <motion.div
              key={ind.label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
              className="rounded-2xl border border-white/10 bg-ink-950/40 p-4 transition hover:border-white/20 hover:bg-ink-950/60"
            >
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-accent-500/20 to-teal-500/20 text-accent-400">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-4 w-4"
                >
                  {ind.icon}
                </svg>
              </div>
              <p className="mt-3 font-display text-sm font-semibold text-white">
                {ind.label}
              </p>
              <p className="mt-1 text-[11px] leading-relaxed text-white/55">
                {ind.detail}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
